import React from "react"

import StylesReader from "../../../hoc/StylesReader"

const Image = ({ source, imageUrl, ...props }) => {
  return <img src={imageUrl || source} {...props} alt={imageUrl || (source && source.uri)} />
}

export default StylesReader(Image)
